<template>
<div class="form">
  <v-card style="margin-top: 250px">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <h1 align="center" style="text-decoration: underline overline;">HK7 - PERTANIAN DAN TERNAKAN KELUARAN SENDIRI YANG DIGUNAKAN</h1>

      <v-text-field
        outlined 
        dense
        rounded
        v-model="HID"
        label="HID"
        width="20px"
        disabled
      ></v-text-field>

    <!-- DATATABLE  -->
    <v-card  color="rgba(217, 217, 217, 0.5)" class="mb-5">
          <v-card-title>
              Senarai
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>

            <v-spacer></v-spacer>
              <v-btn
              color="error"
              small
              @click="dialogPengesahan=true;"
              >
                Padam
            </v-btn>

          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="dataHK7"
            :search="search"
            class="ml-3 mr-3"
            @click:row="handleClick"
            :footer-props="{'items-per-page-options':[3,15, 30, 50, 100, -1]}"
          >
          <template v-slot:item.Sayur_tahun= "{ item }">
                 {{ formatNumber(item.Sayur_tahun) }}
          </template>
          <template v-slot:item.Kelapa_tahun= "{ item }">
                 {{ formatNumber(item.Kelapa_tahun) }}
          </template> 
          <template v-slot:item.Ikan_tahun= "{ item }">
                 {{ formatNumber(item.Ikan_tahun) }}
          </template> 
          <template v-slot:item.Ayam_tahun= "{ item }">
                 {{ formatNumber(item.Ayam_tahun) }}
          </template>
          <template v-slot:item.Itik_tahun= "{ item }">
                 {{ formatNumber(item.Itik_tahun) }}
          </template>
          <template v-slot:item.Telur_tahun= "{ item }">
                 {{ formatNumber(item.Telur_tahun) }}
          </template>
          <template v-slot:item.Rambutan_tahun= "{ item }">
                 {{ formatNumber(item.Rambutan_tahun) }}
          </template>
          <template v-slot:item.Durian_tahun= "{ item }">
                 {{ formatNumber(item.Durian_tahun) }}
          </template>
          <template v-slot:item.Pisang_tahun= "{ item }">
                 {{ formatNumber(item.Pisang_tahun) }}
          </template>
          <template v-slot:item.KayuApi_tahun= "{ item }">
                 {{ formatNumber(item.KayuApi_tahun) }}
          </template>
          <template v-slot:item.LL_tahun= "{ item }">
                 {{ formatNumber(item.LL_tahun) }}
          </template>
          <template v-slot:item.LL1_tahun= "{ item }">
                 {{ formatNumber(item.LL1_tahun) }}
          </template>
          <template v-slot:item.LLD_tahun= "{ item }">
                 {{ formatNumber(item.LLD_tahun) }}
          </template>
          <template v-slot:item.LLD1_tahun= "{ item }">
                 {{ formatNumber(item.LLD1_tahun) }}
          </template>
          <template v-slot:item.LLD3_tahun= "{ item }">
                 {{ formatNumber(item.LLD3_tahun) }}
          </template>
          <template v-slot:item.LLD4_tahun= "{ item }">
                 {{ formatNumber(item.LLD4_tahun) }}
          </template>
          <template v-slot:item.LLD5_tahun= "{ item }">
                 {{ formatNumber(item.LLD5_tahun) }}
          </template>
          <template v-slot:item.LLD6_tahun= "{ item }">
                 {{ formatNumber(item.LLD6_tahun) }}
          </template>
          <template v-slot:item.LLD7_tahun= "{ item }">
                 {{ formatNumber(item.LLD7_tahun) }}
          </template>
          <template v-slot:item.INCS21KS= "{ item }">
                 {{ formatNumber(item.INCS21KS) }}
          </template>
        </v-data-table>
    </v-card>  
  </v-card> 

  <v-card>
    <v-card-title>
    S74 : Senaraikan barang pertanian, penternakan dan perikanan keluaran sendiri yang digunakan beserta anggaran jumlah dalam tahun
  </v-card-title>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
    > 
    <v-card-text>
      <div>

          <v-row>

            <v-col cols="2">
              Item
              <td>Sayur-sayuran</td>
            </v-col>
          
            <v-col cols="2">
              <v-text-field
                          v-model="Sayur_tahun"
                          class="form-control"
                          outlined
                          label="RM"
                          type="number"
                          dense
                          hint="Setahun"
                          @keypress="limitDigits"
                          :rules="schemeRule.no8digit" 
              ></v-text-field>
            </v-col>

          </v-row>
          <v-row>
         
          <v-col cols="2">
            Item
            <td>Kelapa</td>
          </v-col>

          <v-col cols="2">
            <v-text-field
                        v-model="Kelapa_tahun"
                        class="form-control"
                        outlined
                        label="RM"
                        type="number"
                        dense
                        hint="Setahun"
                        @keypress="limitDigits"
                        :rules="schemeRule.no8digit" 
            ></v-text-field>
          </v-col>

          </v-row>
          <v-row>
         
          <v-col cols="2">
            Item
            <td>Ikan</td>
          </v-col>

          <v-col cols="2">
            <v-text-field
                        v-model="Ikan_tahun"
                        class="form-control"
                        outlined
                        label="RM"
                        type="number"
                        dense
                        hint="Setahun"
                        @keypress="limitDigits"
                        :rules="schemeRule.no8digit" 
            ></v-text-field>
          </v-col>

          </v-row>
          
          <v-row>
         
          <v-col cols="2">
            Item
            <td>Ayam</td>
          
          </v-col>

          <v-col cols="2">
            <v-text-field
                        v-model="Ayam_tahun"
                        class="form-control"
                        outlined
                        label="RM"
                        type="number"
                        dense
                        hint="Setahun"
                        @keypress="limitDigits"
                       :rules="schemeRule.no8digit" 
            ></v-text-field>
          </v-col>

        
          
          </v-row>
          
          <v-row>
         
          <v-col cols="2">
            Item
            <td>Itik</td>
          </v-col>

          <v-col cols="2">
            <v-text-field
                        v-model="Itik_tahun"
                        class="form-control"
                        outlined
                        label="RM"
                        type="number"
                        dense
                        hint="Setahun"
                        @keypress="limitDigits"
                        :rules="schemeRule.no8digit" 
            ></v-text-field>
          </v-col>

          </v-row>
          
          <v-row>
         
          <v-col cols="2">
            Item
            <td>Telur</td>
          </v-col>

          <v-col cols="2">
            <v-text-field
                        v-model="Telur_tahun"
                        class="form-control"
                        outlined
                        label="RM"
                        type="number"
                        dense
                        hint="Setahun"
                        @keypress="limitDigits"
                        :rules="schemeRule.no8digit" 
            ></v-text-field>
          </v-col>

          </v-row>
          
          <v-row>
         
          <v-col cols="2">
            Item
            <td>Rambutan</td>
          </v-col>

          <v-col cols="2">
            <v-text-field
                        v-model="Rambutan_tahun"
                        class="form-control"
                        outlined
                        label="RM"
                        type="number"
                        dense
                        hint="Setahun"
                        @keypress="limitDigits"
                        :rules="schemeRule.no8digit" 
            ></v-text-field>
          </v-col>

          </v-row>
         
          <v-row>
         
          <v-col cols="2">
            Item
            <td>Durian</td>
          </v-col>

          <v-col cols="2">
            <v-text-field
                        v-model="Durian_tahun"
                        class="form-control"
                        outlined
                        label="RM"
                        type="number"
                        dense
                        hint="Setahun"
                        @keypress="limitDigits"
                        :rules="schemeRule.no8digit" 
            ></v-text-field>
          </v-col>

          </v-row>
         
          <v-row>
         
          <v-col cols="2">
            Item
            <td>Pisang</td>
          </v-col>

          <v-col cols="2">
            <v-text-field
                        v-model="Pisang_tahun"
                        class="form-control"
                        outlined
                        label="RM"
                        type="number"
                        dense
                        hint="Setahun"
                        @keypress="limitDigits"
                        :rules="schemeRule.no8digit" 
            ></v-text-field>
          </v-col>

          </v-row>
         
         <v-row>
         
          <v-col cols="2">
            Item
            <td>Kayu Api</td>
          </v-col>

          <v-col cols="2">
            <v-text-field
                        v-model="KayuApi_tahun"
                        class="form-control"
                        outlined
                        label="RM"
                        type="number"
                        dense
                        hint="Setahun"
                        @keypress="limitDigits"
                        :rules="schemeRule.no8digit" 
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
           <v-col cols="2">
                Item
                 <v-text-field
                      v-model="LL_tahun"
                      label=""
                      outlined
                      type="text"
                      dense
                      
                ></v-text-field>
            </v-col>
           
          <v-col cols="2">
             <br>
            <v-text-field
                        v-model="LL1_tahun"
                        class="form-control"
                        outlined
                        label="RM"
                        type="number"
                        dense
                        hint="Setahun"
                        @keypress="limitDigits"
                       :rules="schemeRule.no8digit" 
            ></v-text-field>
          </v-col>
        </v-row>
        
        <v-row>
           <v-col cols="2">
                Item
                 <v-text-field
                      v-model="LLD_tahun"
                      label=""
                      outlined
                      type="text"
                      dense
                      
                ></v-text-field>
            </v-col>
            

          <v-col cols="2">
            <br>
            <v-text-field
                        v-model="LLD1_tahun"
                        class="form-control"
                        outlined
                        label="RM"
                        type="number"
                        dense
                        hint="Setahun"
                        @keypress="limitDigits"
                        :rules="schemeRule.no8digit" 
            ></v-text-field>
          </v-col>
        </v-row>
        
        <v-row>
           <v-col cols="2">
                Item
                 <v-text-field
                      v-model="LLD2_tahun"
                      label=""
                      outlined
                      type="text"
                      dense
                      
                ></v-text-field>
            </v-col>
            

          <v-col cols="2">
            <br>
            <v-text-field
                        v-model="LLD3_tahun"
                        class="form-control"
                        outlined
                        label="RM"
                        type="number"
                        dense
                        hint="Setahun"
                        @keypress="limitDigits"
                        :rules="schemeRule.no8digit" 
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
           <v-col cols="2">
                Item
                 <v-text-field
                      v-model="LLD4_tahun"
                      label=""
                      outlined
                      type="text"
                      dense
                      
                ></v-text-field>
            </v-col>
            

          <v-col cols="2">
            <br>
            <v-text-field
                        v-model="LLD5_tahun"
                        class="form-control"
                        outlined
                        label="RM"
                        type="number"
                        dense
                        hint="Setahun"
                        @keypress="limitDigits"
                        :rules="schemeRule.no8digit" 
            ></v-text-field>
          </v-col>
        </v-row>

         <v-row>
           <v-col cols="2">
                Item
                 <v-text-field
                      v-model="LLD6_tahun"
                      label=""
                      outlined
                      type="text"
                      dense
                ></v-text-field>
            </v-col>
            

          <v-col cols="2">
            <br>
            <v-text-field
                        v-model="LLD7_tahun"
                        class="form-control"
                        outlined
                        label="RM"
                        type="number"
                        dense
                        hint="Setahun"
                        @keypress="limitDigits"
                  :rules="schemeRule.no8digit" 
            ></v-text-field>
          </v-col>
        </v-row>
     </div>


        <v-row>
         
          <v-col cols="2">
          <td>Jumlah</td>
          </v-col>
          <v-col cols="2">
            <v-text-field
                        v-model="INCS21KS"
                        class="form-control"
                        outlined
                        type="text"
                        dense
                        :disabled = "true"
            ></v-text-field>
          </v-col>

        </v-row>
  
     
  </v-card-text>
</v-form>
 <!-- <v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
        text
        color="primary"
        @click='simpan()'
    >
      Simpan
    </v-btn>
    <v-btn
      text
      color="primary"
      @click="goTo()"
    >
      Seterusnya
    </v-btn>
</v-card-actions> -->
<v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
        text
        color="primary"
        @click='simpan()'
        v-show="butangSimpan"
    >
      Simpan
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="updateHK7()"
    >
      Kemaskini
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="goTo('2')"
    >
      Seterusnya
    </v-btn>
</v-card-actions>
</v-card>

<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<!-- <v-dialog
      v-model="successDialog"
      width="500"
      height="200"
    >
    <v-card
    color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog> -->

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      max-width="800"
      height="200"
    >
    <v-card
      color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>

      <v-card-actions> 
        <v-spacer></v-spacer>
            <v-btn
                color="warning"
                @click='successDialog = false;'
            >
              Batal
            </v-btn>
            <!-- <v-btn
                color="primary"
                @click='goTo("1")'
            >
              Ke Ringkasan Isi Rumah
            </v-btn> -->
            <v-btn
              color="primary"
              @click='goTo("2")'
            >
              Pengisian Seterusnya
            </v-btn>
      </v-card-actions>
    </v-card>
</v-dialog>

<!-- Kemaskini Dialog -->
<v-dialog
      v-model="kemaskiniDialog"
      max-width="800"
      height="200"
    >
    <v-card
    >
      <v-alert
        dense
        solo
      >
      <strong>Data Dipilih, Sila Mulakan Pengemaskinian</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Pengesahan Padam Dialog -->
 <v-row justify="center">
    <v-dialog
      v-model="dialogPengesahan"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dipadam dan pengisian semula harus dilakukan!")}}</strong><br><br>
         {{$t("Adakah anda pasti untuk memadam pengisian?")}}<br><br>
         <!-- <strong>{{$t(" HID: "+this.HID)}}</strong> -->
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="dialogPengesahan = false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="padamData()"
          >
            {{$t('padam')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

</div>
</template>
<script>
import axios from '../../plugins/axios'
import schemeRule from '../../utils/scheme'
//////////////////////////import services///////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage(); 

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
    // props:['data'],
    async beforeMount(){
        //this.getUnits('ayam')
        var dataHID = localStorageData.getHIDdata()

        this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOIR = dataHID.NOIR;
        this.Bulan = dataHID.BULAN;
        this.Tahun = dataHID.TAHUN;

        // this.masco = await lookupFieldServices.getMasco(); //dapatkan lookup masco
        // this.msic = await lookupFieldServices.getMsic(); //dapatkan lookup msic
        // this.yaTidak = lookupFieldServices.getYaTidak();
        // this.jenisrumah = lookupFieldServices.getjenisrumah();

        this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        this.NOAIR = this.currNOAIRData.NOAIR;
        
        this.getData();//dapatkan data based on HID


    },
    setup() {
        
    },
    data: () => ({
        butangSimpan: true,
        butangKemaskini: false,

        dialog: false,
        successDialog: false,
        errorDialog: false,
        successMessage:'',
        errMessage:'',
        message: "Saving Data",
        popUpALert:false,
        kemaskiniDialog: false,
         dialogPengesahan:false,

        search: '',
        currNOAIRData:'',
        masco:[],
        msic:[],
        yaTidak:[],
        jenisrumah:[],
        dataHK7:[],
      
        /////////////////////data declaration//////////////////////////
        HID: '',
        KAW: 1,
        Bulan:'',
        Tahun:'',
        BNO:'',
        Ps:'',
        S:'',
        NG: '',
        DP:'',
        DB:'',
        BP:'',
        ST:'',
        NOTK:'',
        NOIR:'',
        R:1,

        Sayur_tahun:0,
        Kelapa_tahun:0,
        Ikan_tahun:0,
        Ayam_tahun:0,
        Itik_tahun:0,
        Telur_tahun:0,
        Rambutan_tahun:0,
        Durian_tahun:0,
        Pisang_tahun:0,
        KayuApi_tahun:0,
        //INCS21KS:0,
        LL_tahun:'',
        LL1_tahun:0,
        LLD_tahun:'',
        LLD1_tahun:0,
        LLD2_tahun:'',
        LLD3_tahun:0,
        LLD4_tahun:'',
        LLD5_tahun:0,
        LLD6_tahun:'',
        LLD7_tahun:0,
        headers: [
          {
            text: 'NOAIR',
            align: 'start',
            sortable: false,
            value: 'NOAIR',
          },
          { text: 'Sayur ', value: 'Sayur_tahun' },
          { text: 'Kelapa  ', value: 'Kelapa_tahun' },
          { text: 'Ikan ', value: 'Ikan_tahun' },
          { text: 'Ayam ', value: 'Ayam_tahun' },
          { text: 'Itik ', value: 'Itik_tahun' },
          { text: 'Telur ', value: 'Telur_tahun' },
          { text: 'Rambutan ', value: 'Rambutan_tahun' },
          { text: 'Durian ', value: 'Durian_tahun' },
          { text: 'Pisang ', value: 'Pisang_tahun' },
          { text: 'Kayu Api ', value: 'KayuApi_tahun' },
          { text: 'Item Lain', value: 'LL_tahun' },
          { text: 'Lain-lain (RM)', value: 'LL1_tahun' },
          { text: 'Item Lain 2', value: 'LLD_tahun' },
          { text: 'Lain-lain (RM)', value: 'LLD1_tahun' },
          { text: 'Item Lain 3', value: 'LLD2_tahun' },
          { text: 'Lain-lain (RM)', value: 'LLD3_tahun' },
          { text: 'Item Lain 4', value: 'LLD4_tahun' },
          { text: 'Lain-lain (RM)', value: 'LLD5_tahun' },
          { text: 'Item Lain 5', value: 'LLD6_tahun' },
          { text: 'Lain-lain (RM)', value: 'LLD7_tahun' },
          { text: 'INCS 21KS', value: 'INCS21KS' },
          
          
          //{ text: 'HKI Pendapatan', value: 'PENHK1' },
        ],
       //////////link untuk ke page/////////////////////
       breadcrumbs: [
        {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
        {
          text: 'HK7',
          disabled: true,
          href: 'hk7',
        },
      ],
        // breadcrumbs: [
        //   {
        //     text: 'Ringkasan Isi Rumah',
        //     disabled: false,
        //     href: 'ringkasanMaklumatIR',
        //   },
        //   {
        //     text: 'HK1',
        //     disabled: true,
        //     href: 'hk1',
        //   },
        //   {
        //     text: 'HK2',
        //     disabled: true,
        //     href: 'hk2',
        //   },
        //     {
        //     text: 'HK3',
        //     disabled: true,
        //     href: 'hk3',
        //   },
        //     {
        //     text: 'HK4',
        //     disabled: true,
        //     href: 'hk4',
        //   },
        //     {
        //     text: 'HK5',
        //     disabled: true,
        //     href: 'hk5',
        //   },
        //     {
        //     text: 'HK6',
        //     disabled: true,
        //     href: 'hk6',
        //   },
        //     {
        //     text: 'HK7',
        //     disabled: true,
        //     href: 'hk7',
        //   },
        //   {
        //     text: 'HK8',
        //     disabled: true,
        //     href: 'hk8',
        //   },
        
        // ],
    }),

    

methods: {
  validate () {
    this.$refs.form.validate()
  },
  limitDigits(event) {
        const value = event.target.value;
        if (value.length >= 8) {
            event.preventDefault();
        }
      },
  formatNumber(value) {
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
  stripCommas(value) {
      return value.replace(/,/g, '');
      },
  reset () {
    this.$refs.form.reset()
  },
  resetValidation () {
    this.$refs.form.resetValidation()
  },
  async simpan (){
    //alert(this.INCS21KS)
    // if (this.$refs.form.validate()){
        this.dialog =  true;
        setTimeout(() => (this.dialog = false), 2000)
      
        try {

            const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/HK7`, {
            
            HID:  this.HID,
            NOAIR: this.NOAIR,
            Sayur_tahun: this.Sayur_tahun, 
            Kelapa_tahun: this.Kelapa_tahun,
            Ikan_tahun: this.Ikan_tahun,
            Ayam_tahun: this.Ayam_tahun,
            Itik_tahun: this.Itik_tahun,
            Telur_tahun: this.Telur_tahun,
            Rambutan_tahun: this.Rambutan_tahun,
            Durian_tahun: this.Durian_tahun,
            Pisang_tahun: this.Pisang_tahun,
            KayuApi_tahun: this.KayuApi_tahun,
            LL_tahun: this.LL_tahun,
            LL1_tahun: this.LL1_tahun,
            LLD_tahun: this.LLD_tahun,
            LLD1_tahun: this.LLD1_tahun,
            LLD2_tahun: this.LLD2_tahun,
            LLD3_tahun: this.LLD3_tahun,
            LLD4_tahun: this.LLD4_tahun,
            LLD5_tahun: this.LLD5_tahun,
            LLD6_tahun: this.LLD6_tahun,
            LLD7_tahun: this.LLD7_tahun,
            INCS21KS: this.INCS21KS,
            
          })
              this.res = res.data;
              this.getData();
              this.successMessage = 'Data Disimpan!';
              this.successDialog = true;
              window.scrollTo(0, 0);
            // this.successMessage = 'Data Disimpan!';
            // this.successDialog = true;
            // setTimeout(() => (this.successDialog = false), 2000);
            // this.reset();
            // this.getData();
            // window.scrollTo(0, 0);
            //this.getData();
            //setTimeout(() => (this.goTo()), 1000);
            
        } catch (error) {
          
          //console.log(error)
          this.errorDialog = true;
          setTimeout(() => (this.errorDialog = false), 2000);
          this.errMessage = 'Simpan : '+error;
        }
  },
  async updateHK7(){
    //alert(this.INCS21KS)
    // if (this.$refs.form.validate()){
        this.dialog =  true;
        setTimeout(() => (this.dialog = false), 2000)
      
        try {

            const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/updateHK7`, {
            
            HID:  this.HID,
            NOAIR: this.NOAIR,
            Sayur_tahun: this.Sayur_tahun, 
            Kelapa_tahun: this.Kelapa_tahun,
            Ikan_tahun: this.Ikan_tahun,
            Ayam_tahun: this.Ayam_tahun,
            Itik_tahun: this.Itik_tahun,
            Telur_tahun: this.Telur_tahun,
            Rambutan_tahun: this.Rambutan_tahun,
            Durian_tahun: this.Durian_tahun,
            Pisang_tahun: this.Pisang_tahun,
            KayuApi_tahun: this.KayuApi_tahun,
            LL_tahun: this.LL_tahun,
            LL1_tahun: this.LL1_tahun,
            LLD_tahun: this.LLD_tahun,
            LLD1_tahun: this.LLD1_tahun,
            LLD2_tahun: this.LLD2_tahun,
            LLD3_tahun: this.LLD3_tahun,
            LLD4_tahun: this.LLD4_tahun,
            LLD5_tahun: this.LLD5_tahun,
            LLD6_tahun: this.LLD6_tahun,
            LLD7_tahun: this.LLD7_tahun,
            INCS21KS: this.INCS21KS,
            
          })
            this.res = res.data;
              this.reset();
              this.getData();
              this.butangKemaskini = false;
              this.successMessage = 'Data Dikemaskini!';
              this.successDialog = true;
              window.scrollTo(0, 0);
            // this.successMessage = 'Data Disimpan!';
            // this.successDialog = true;
            // setTimeout(() => (this.successDialog = false), 2000);
            // this.reset();
            // this.getData();
            // window.scrollTo(0, 0);
            //this.getData();
            //setTimeout(() => (this.goTo()), 1000);
            
        } catch (error) {
          
          //console.log(error)
          this.errorDialog = true;
          setTimeout(() => (this.errorDialog = false), 2000);
          this.errMessage = 'Simpan : '+error;
        }
  },
  async padam(val){
    if(val == 0){
      this.popUpALert = true; 
    }
    else if(val == 1){
      
      try {
          ///////////tunjukkan alert padam////////////
          this.popUpALert = false;
            ////send delete to API///////
          if (this.$refs.form.validate()){
            const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/HK7/delete`, {
            HID:  this.HID,
            NOAIR: this.NOAIR,
          })
            this.res = res.data
            this.successDialog = true;
            setTimeout(() => (this.successDialog = false), 2000);
            this.successMessage = 'Data Deleted!'
            this.saveButton = false;
            this.updateButton = true;
            this.reset();
            this.getData(); 
          }else{
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = "Please Fill In the field"
          }
          
        } catch (error) {
          //console.log(error)
          this.errorDialog = true;
          setTimeout(() => (this.errorDialog = false), 2000);
          this.errMessage = 'Padam : '+error;
        }
    }
    else if(val == 2){
      this.popUpALert = false;
    }
      
  },
  async padamData(){

        try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/delete`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
                table: "HK7"
              })
                this.res = res.data;
                this.reset();
                this.dialogPengesahan = false;
                this.successDialog = true;
                // this.butangSimpan = true;
                setTimeout(() => (this.successDialog = false), 1000);
                this.successMessage = 'Data Dipadam!'
                this.getData(); 
              
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }  
      },
  async getData(){
        //dapatkan data dari table HK1 based on HID
   
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/HK/HK7?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
            })
            var dataz = res.data.data
            this.dataHK7 = dataz;
          } catch (error) {
            //console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }
  },
  handleClick(row) {
          this.kemaskiniDialog = true;
          setTimeout(() => (this.kemaskiniDialog = false), 1000);

          this.butangSimpan = false;
          this.butangKemaskini = true;

          this.NOAIR = row.NOAIR;
          this.Bil = row.Bil;
          this.Sayur_tahun = this.stripCommas(row.Sayur_tahun);
          this.Kelapa_tahun = this.stripCommas(row.Kelapa_tahun);
          this.Ikan_tahun = this.stripCommas(row.Ikan_tahun);
          this.Ayam_tahun = this.stripCommas(row.Ayam_tahun);
          this.Itik_tahun = this.stripCommas(row.Itik_tahun);
          this.Telur_tahun = this.stripCommas(row.Telur_tahun);
          this.Rambutan_tahun = this.stripCommas(row.Rambutan_tahun);
          this.Durian_tahun = this.stripCommas(row.Durian_tahun);
          this.Pisang_tahun = this.stripCommas(row.Pisang_tahun);
          this.KayuApi_tahun = this.stripCommas(row.KayuApi_tahun);
          this.LL_tahun = this.stripCommas(row.LL_tahun);
          this.LL1_tahun = this.stripCommas(row.LL1_tahun);
          this.LLD_tahun = this.stripCommas(row.LLD_tahun);
          this.LLD1_tahun = this.stripCommas(row.LLD1_tahun);
          this.LLD2_tahun = this.stripCommas(row.LLD2_tahun);
          this.LLD3_tahun = this.stripCommas(row.LLD3_tahun);
          this.LLD4_tahun = this.stripCommas(row.LLD4_tahun);
          this.LLD5_tahun = this.stripCommas(row.LLD5_tahun);
          this.LLD6_tahun = this.stripCommas(row.LLD6_tahun);
          this.LLD7_tahun = this.stripCommas(row.LLD7_tahun);
          this.INCS21KS = this.stripCommas(row.INCS21KS);
          
  },
  goTo(option){

        if(option == "1"){
          this.$router.push({name: "ringkasanMaklumatIR"});
        }

        if(option == "2"){
          this.$router.push({name: "hk8"});
        }   
  }
},
  watch:{
     dataHK7(){
        if(this.dataHK7.length > 0){
          this.butangSimpan = false;
        }
      }
      // KayuApi_tahun(){
      //   this.INCS21KS = Number(this.Sayur_tahun) + Number(this.Kelapa_tahun) + Number(this.Ikan_tahun) + Number(this.Ayam_tahun) + Number(this.Itik_tahun)
      //   + Number(this.Telur_tahun) + Number(this.Rambutan_tahun) + Number(this.Durian_tahun) + Number(this.Pisang_tahun) + Number(this.KayuApi_tahun);
      // },
      // LL1_tahun(){
      //   this.INCS21KS = Number(this.Sayur_tahun) + Number(this.Kelapa_tahun) + Number(this.Ikan_tahun) + Number(this.Ayam_tahun) + Number(this.Itik_tahun)
      //   + Number(this.Telur_tahun) + Number(this.Rambutan_tahun) + Number(this.Durian_tahun) + Number(this.Pisang_tahun) + Number(this.KayuApi_tahun)
      //   + Number(this.LL1_tahun);
      // },
      // LLD1_tahun(){
      //   this.INCS21KS = Number(this.Sayur_tahun) + Number(this.Kelapa_tahun) + Number(this.Ikan_tahun) + Number(this.Ayam_tahun) + Number(this.Itik_tahun)
      //   + Number(this.Telur_tahun) + Number(this.Rambutan_tahun) + Number(this.Durian_tahun) + Number(this.Pisang_tahun) + Number(this.KayuApi_tahun)
      //   + Number(this.LL1_tahun) + Number(this.LLD1_tahun);
      // },
      // LLD3_tahun(){
      //   this.INCS21KS = Number(this.Sayur_tahun) + Number(this.Kelapa_tahun) + Number(this.Ikan_tahun) + Number(this.Ayam_tahun) + Number(this.Itik_tahun)
      //   + Number(this.Telur_tahun) + Number(this.Rambutan_tahun) + Number(this.Durian_tahun) + Number(this.Pisang_tahun) + Number(this.KayuApi_tahun)
      //   + Number(this.LL1_tahun) + Number(this.LLD1_tahun) + Number(this.LLD3_tahun);
      // },
   },
   computed:{
     INCS21KS: function(){
       var total = 0;
       total = total + Number(this.Sayur_tahun) + Number(this.Kelapa_tahun) + Number(this.Ikan_tahun) + Number(this.Ayam_tahun) + Number(this.Itik_tahun)
        + Number(this.Telur_tahun) + Number(this.Rambutan_tahun) + Number(this.Durian_tahun) + Number(this.Pisang_tahun) + Number(this.KayuApi_tahun)
        + Number(this.LL1_tahun) + Number(this.LLD1_tahun) + Number(this.LLD3_tahun) + Number(this.LLD5_tahun) + Number(this.LLD7_tahun);

        return total;
     },
     schemeRule() {
      return schemeRule;
    },

   }
    
    
}
</script>

<style>
#app {
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
}

</style>